"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "durationAsMilliseconds", {
    enumerable: !0,
    get: function() {
        return durationAsMilliseconds;
    }
});
const _datefns = require("date-fns");
function durationAsMilliseconds(duration) {
    return +(0, _datefns.add)(0, duration);
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsL0RhdGUudHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBEdXJhdGlvbiB9IGZyb20gJ2RhdGUtZm5zJ1xuaW1wb3J0IHsgYWRkIH0gZnJvbSAnZGF0ZS1mbnMnXG5cbi8qKlxuICogQ29udmVydHMgYSBkYXRlLWZucyBEdXJhdGlvbiBvYmplY3QgdG8gbWlsbGlzZWNvbmRzLlxuICovXG5leHBvcnQgZnVuY3Rpb24gZHVyYXRpb25Bc01pbGxpc2Vjb25kcyhkdXJhdGlvbjogRHVyYXRpb24pOiBudW1iZXIge1xuICAgIHJldHVybiArYWRkKDAsIGR1cmF0aW9uKVxufVxuIl0sIm5hbWVzIjpbImR1cmF0aW9uQXNNaWxsaXNlY29uZHMiLCJkdXJhdGlvbiIsImFkZCJdLCJtYXBwaW5ncyI6Ijs7O21DQU1nQkE7OztlQUFBQTs7O3lCQUxJO0FBS2IsU0FBU0EsdUJBQXVCQyxRQUFrQjtJQUNyRCxPQUFPLENBQUNDLElBQUFBLFlBQUcsRUFBQyxHQUFHRDtBQUNuQiJ9